// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/auth/v1/agent.proto (package chalk.auth.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FeaturePermissions } from "./featurepermission_pb";
import { file_chalk_auth_v1_featurepermission } from "./featurepermission_pb";
import type { Permission } from "./permissions_pb";
import { file_chalk_auth_v1_permissions } from "./permissions_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/auth/v1/agent.proto.
 */
export const file_chalk_auth_v1_agent: GenFile = /*@__PURE__*/
  fileDesc("ChljaGFsay9hdXRoL3YxL2FnZW50LnByb3RvEg1jaGFsay5hdXRoLnYxIr0BChZFbnZpcm9ubWVudFBlcm1pc3Npb25zEi4KC3Blcm1pc3Npb25zGAIgAygOMhkuY2hhbGsuYXV0aC52MS5QZXJtaXNzaW9uEj4KE2ZlYXR1cmVfcGVybWlzc2lvbnMYAyABKAsyIS5jaGFsay5hdXRoLnYxLkZlYXR1cmVQZXJtaXNzaW9ucxIzCg9jdXN0b21lcl9jbGFpbXMYBCADKAsyGi5jaGFsay5hdXRoLnYxLkN1c3RvbUNsYWltIkEKD1RlYW1QZXJtaXNzaW9ucxIuCgtwZXJtaXNzaW9ucxgBIAMoDjIZLmNoYWxrLmF1dGgudjEuUGVybWlzc2lvbiLYAgoJVXNlckFnZW50EhUKCWNsaWVudF9pZBgBIAEoCUICGAESDwoHdXNlcl9pZBgCIAEoCRIPCgd0ZWFtX2lkGAMgASgJEloKGnBlcm1pc3Npb25zX2J5X2Vudmlyb25tZW50GAQgAygLMjYuY2hhbGsuYXV0aC52MS5Vc2VyQWdlbnQuUGVybWlzc2lvbnNCeUVudmlyb25tZW50RW50cnkSFAoMaW1wZXJzb25hdGVkGAUgASgIEjgKEHRlYW1fcGVybWlzc2lvbnMYBiABKAsyHi5jaGFsay5hdXRoLnYxLlRlYW1QZXJtaXNzaW9ucxpmCh1QZXJtaXNzaW9uc0J5RW52aXJvbm1lbnRFbnRyeRILCgNrZXkYASABKAkSNAoFdmFsdWUYAiABKAsyJS5jaGFsay5hdXRoLnYxLkVudmlyb25tZW50UGVybWlzc2lvbnM6AjgBIioKC0N1c3RvbUNsYWltEgsKA2tleRgBIAEoCRIOCgZ2YWx1ZXMYAiADKAkizQIKEVNlcnZpY2VUb2tlbkFnZW50EgoKAmlkGAEgASgJEhEKCWNsaWVudF9pZBgCIAEoCRIPCgd0ZWFtX2lkGAMgASgJEhMKC2Vudmlyb25tZW50GAQgASgJEi4KC3Blcm1pc3Npb25zGAUgAygOMhkuY2hhbGsuYXV0aC52MS5QZXJtaXNzaW9uEhkKDWN1c3RvbV9jbGFpbXMYBiADKAlCAhgBEjMKD2N1c3RvbWVyX2NsYWltcxgHIAMoCzIaLmNoYWxrLmF1dGgudjEuQ3VzdG9tQ2xhaW0SPgoTZmVhdHVyZV9wZXJtaXNzaW9ucxgIIAEoCzIhLmNoYWxrLmF1dGgudjEuRmVhdHVyZVBlcm1pc3Npb25zEjMKEHRlYW1fcGVybWlzc2lvbnMYCSADKA4yGS5jaGFsay5hdXRoLnYxLlBlcm1pc3Npb24ibAoLRW5naW5lQWdlbnQSCgoCaWQYASABKAkSDwoHdGVhbV9pZBgCIAEoCRISCgpwcm9qZWN0X2lkGAMgASgJEhYKDmVudmlyb25tZW50X2lkGAQgASgJEhQKDGltcGVyc29uYXRlZBgFIAEoCCIWChRNZXRhZGF0YVNlcnZpY2VBZ2VudCLGAQoURXhjaGFuZ2VUb2tlbkRldGFpbHMSOgoXcmVxdWVzdGFibGVfcGVybWlzc2lvbnMYASADKA4yGS5jaGFsay5hdXRoLnYxLlBlcm1pc3Npb24SGQoRZ2VuZXJhdGlvbl9udW1iZXIYAiABKAUSDwoHc3ViamVjdBgDIAEoCRIWCg5lbnZpcm9ubWVudF9pZBgEIAEoCRIuCgRraW5kGAUgASgOMiAuY2hhbGsuYXV0aC52MS5FeGNoYW5nZVRva2VuS2luZCLfAQoLVGVuYW50QWdlbnQSDwoHdGVhbV9pZBgBIAEoCRIuCgtwZXJtaXNzaW9ucxgCIAMoDjIZLmNoYWxrLmF1dGgudjEuUGVybWlzc2lvbhIWCg5lbnZpcm9ubWVudF9pZBgDIAEoCRJIChZleGNoYW5nZV90b2tlbl9kZXRhaWxzGAQgASgLMiMuY2hhbGsuYXV0aC52MS5FeGNoYW5nZVRva2VuRGV0YWlsc0gAiAEBEhIKCmNsdXN0ZXJfaWQYBSABKAlCGQoXX2V4Y2hhbmdlX3Rva2VuX2RldGFpbHMiQwoWU2VsZkhvc3RlZExpY2Vuc2VBZ2VudBIKCgJpZBgBIAEoCRIPCgd0ZWFtX2lkGAIgASgJEgwKBG5hbWUYAyABKAkiKQoSTm90ZWJvb2tTaGFyZVNjb3BlEhMKC25vdGVib29rX2lkGAEgASgJIlQKElJlc291cmNlU2hhcmVTY29wZRI1Cghub3RlYm9vaxgBIAEoCzIhLmNoYWxrLmF1dGgudjEuTm90ZWJvb2tTaGFyZVNjb3BlSABCBwoFc2NvcGUinAEKElJlc291cmNlU2hhcmVBZ2VudBIKCgJpZBgBIAEoCRIPCgd0ZWFtX2lkGAIgASgJEhYKDmVudmlyb25tZW50X2lkGAMgASgJEjAKBXNjb3BlGAQgASgLMiEuY2hhbGsuYXV0aC52MS5SZXNvdXJjZVNoYXJlU2NvcGUSHwoXcmVxdWlyZXNfYXV0aGVudGljYXRpb24YBSABKAgiMAoQU2FuZGJveFByaW5jaXBhbBIKCgJpZBgBIAEoCRIQCghncm91cF9pZBgCIAEoCSKtAwoNV29ya2xvYWRBZ2VudBIPCgd0ZWFtX2lkGAEgASgJEhYKDmVudmlyb25tZW50X2lkGAIgASgJEi4KC3Blcm1pc3Npb25zGAMgAygOMhkuY2hhbGsuYXV0aC52MS5QZXJtaXNzaW9uEjIKB3NhbmRib3gYBCABKAsyHy5jaGFsay5hdXRoLnYxLlNhbmRib3hQcmluY2lwYWxIABI+ChNmZWF0dXJlX3Blcm1pc3Npb25zGAcgASgLMiEuY2hhbGsuYXV0aC52MS5GZWF0dXJlUGVybWlzc2lvbnMSMwoPY3VzdG9tZXJfY2xhaW1zGAggAygLMhouY2hhbGsuYXV0aC52MS5DdXN0b21DbGFpbRJSChR1c2VyX3Byb3ZpZGVkX2NsYWltcxgJIAMoCzI0LmNoYWxrLmF1dGgudjEuV29ya2xvYWRBZ2VudC5Vc2VyUHJvdmlkZWRDbGFpbXNFbnRyeRo5ChdVc2VyUHJvdmlkZWRDbGFpbXNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBQgsKCXByaW5jaXBhbCKLBAoFQWdlbnQSEgoKc2FuZGJveF9pZBgIIAEoCRIuCgp1c2VyX2FnZW50GAEgASgLMhguY2hhbGsuYXV0aC52MS5Vc2VyQWdlbnRIABI/ChNzZXJ2aWNlX3Rva2VuX2FnZW50GAIgASgLMiAuY2hhbGsuYXV0aC52MS5TZXJ2aWNlVG9rZW5BZ2VudEgAEjIKDGVuZ2luZV9hZ2VudBgDIAEoCzIaLmNoYWxrLmF1dGgudjEuRW5naW5lQWdlbnRIABIyCgx0ZW5hbnRfYWdlbnQYBCABKAsyGi5jaGFsay5hdXRoLnYxLlRlbmFudEFnZW50SAASRQoWbWV0YWRhdGFfc2VydmljZV9hZ2VudBgFIAEoCzIjLmNoYWxrLmF1dGgudjEuTWV0YWRhdGFTZXJ2aWNlQWdlbnRIABJKChlzZWxmX2hvc3RlZF9saWNlbnNlX2FnZW50GAYgASgLMiUuY2hhbGsuYXV0aC52MS5TZWxmSG9zdGVkTGljZW5zZUFnZW50SAASQQoUcmVzb3VyY2Vfc2hhcmVfYWdlbnQYByABKAsyIS5jaGFsay5hdXRoLnYxLlJlc291cmNlU2hhcmVBZ2VudEgAEjYKDndvcmtsb2FkX2FnZW50GAkgASgLMhwuY2hhbGsuYXV0aC52MS5Xb3JrbG9hZEFnZW50SABCBwoFYWdlbnQqyAEKEUV4Y2hhbmdlVG9rZW5LaW5kEiMKH0VYQ0hBTkdFX1RPS0VOX0tJTkRfVU5TUEVDSUZJRUQQABIoCiRFWENIQU5HRV9UT0tFTl9LSU5EX0lOVEVSTkFMX1NFUlZJQ0UQARIcChhFWENIQU5HRV9UT0tFTl9LSU5EX1VTRVIQAhIlCiFFWENIQU5HRV9UT0tFTl9LSU5EX1NFUlZJQ0VfVE9LRU4QAxIfChtFWENIQU5HRV9UT0tFTl9LSU5EX1NBTkRCT1gQBCqEAgoJQWdlbnRLaW5kEhoKFkFHRU5UX0tJTkRfVU5TUEVDSUZJRUQQABITCg9BR0VOVF9LSU5EX1VTRVIQARIcChhBR0VOVF9LSU5EX1NFUlZJQ0VfVE9LRU4QAhIVChFBR0VOVF9LSU5EX0VOR0lORRADEhUKEUFHRU5UX0tJTkRfVEVOQU5UEAQSHwobQUdFTlRfS0lORF9NRVRBREFUQV9TRVJWSUNFEAUSIgoeQUdFTlRfS0lORF9TRUxGX0hPU1RFRF9MSUNFTlNFEAYSHQoZQUdFTlRfS0lORF9SRVNPVVJDRV9TSEFSRRAHEhYKEkFHRU5UX0tJTkRfU0FOREJPWBAIQhBaDmF1dGgvdjE7YXV0aHYxYgZwcm90bzM", [file_chalk_auth_v1_featurepermission, file_chalk_auth_v1_permissions]);

/**
 * @generated from message chalk.auth.v1.EnvironmentPermissions
 */
export type EnvironmentPermissions = Message<"chalk.auth.v1.EnvironmentPermissions"> & {
  /**
   * @generated from field: repeated chalk.auth.v1.Permission permissions = 2;
   */
  permissions: Permission[];

  /**
   * @generated from field: chalk.auth.v1.FeaturePermissions feature_permissions = 3;
   */
  featurePermissions?: FeaturePermissions;

  /**
   * @generated from field: repeated chalk.auth.v1.CustomClaim customer_claims = 4;
   */
  customerClaims: CustomClaim[];
};

/**
 * Describes the message chalk.auth.v1.EnvironmentPermissions.
 * Use `create(EnvironmentPermissionsSchema)` to create a new message.
 */
export const EnvironmentPermissionsSchema: GenMessage<EnvironmentPermissions> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_agent, 0);

/**
 * @generated from message chalk.auth.v1.TeamPermissions
 */
export type TeamPermissions = Message<"chalk.auth.v1.TeamPermissions"> & {
  /**
   * @generated from field: repeated chalk.auth.v1.Permission permissions = 1;
   */
  permissions: Permission[];
};

/**
 * Describes the message chalk.auth.v1.TeamPermissions.
 * Use `create(TeamPermissionsSchema)` to create a new message.
 */
export const TeamPermissionsSchema: GenMessage<TeamPermissions> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_agent, 1);

/**
 * @generated from message chalk.auth.v1.UserAgent
 */
export type UserAgent = Message<"chalk.auth.v1.UserAgent"> & {
  /**
   * @generated from field: string client_id = 1 [deprecated = true];
   * @deprecated
   */
  clientId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string team_id = 3;
   */
  teamId: string;

  /**
   * @generated from field: map<string, chalk.auth.v1.EnvironmentPermissions> permissions_by_environment = 4;
   */
  permissionsByEnvironment: { [key: string]: EnvironmentPermissions };

  /**
   * @generated from field: bool impersonated = 5;
   */
  impersonated: boolean;

  /**
   * @generated from field: chalk.auth.v1.TeamPermissions team_permissions = 6;
   */
  teamPermissions?: TeamPermissions;
};

/**
 * Describes the message chalk.auth.v1.UserAgent.
 * Use `create(UserAgentSchema)` to create a new message.
 */
export const UserAgentSchema: GenMessage<UserAgent> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_agent, 2);

/**
 * CustomClaim is used to encode customer permissions.
 * The keys used are:
 * - `query_tags`: The tags of features that the user is allowed to query.
 *
 * @generated from message chalk.auth.v1.CustomClaim
 */
export type CustomClaim = Message<"chalk.auth.v1.CustomClaim"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: repeated string values = 2;
   */
  values: string[];
};

/**
 * Describes the message chalk.auth.v1.CustomClaim.
 * Use `create(CustomClaimSchema)` to create a new message.
 */
export const CustomClaimSchema: GenMessage<CustomClaim> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_agent, 3);

/**
 * @generated from message chalk.auth.v1.ServiceTokenAgent
 */
export type ServiceTokenAgent = Message<"chalk.auth.v1.ServiceTokenAgent"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string client_id = 2;
   */
  clientId: string;

  /**
   * @generated from field: string team_id = 3;
   */
  teamId: string;

  /**
   * @generated from field: string environment = 4;
   */
  environment: string;

  /**
   * @generated from field: repeated chalk.auth.v1.Permission permissions = 5;
   */
  permissions: Permission[];

  /**
   * @generated from field: repeated string custom_claims = 6 [deprecated = true];
   * @deprecated
   */
  customClaims: string[];

  /**
   * @generated from field: repeated chalk.auth.v1.CustomClaim customer_claims = 7;
   */
  customerClaims: CustomClaim[];

  /**
   * @generated from field: chalk.auth.v1.FeaturePermissions feature_permissions = 8;
   */
  featurePermissions?: FeaturePermissions;

  /**
   * @generated from field: repeated chalk.auth.v1.Permission team_permissions = 9;
   */
  teamPermissions: Permission[];
};

/**
 * Describes the message chalk.auth.v1.ServiceTokenAgent.
 * Use `create(ServiceTokenAgentSchema)` to create a new message.
 */
export const ServiceTokenAgentSchema: GenMessage<ServiceTokenAgent> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_agent, 4);

/**
 * @generated from message chalk.auth.v1.EngineAgent
 */
export type EngineAgent = Message<"chalk.auth.v1.EngineAgent"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;

  /**
   * @generated from field: string project_id = 3;
   */
  projectId: string;

  /**
   * @generated from field: string environment_id = 4;
   */
  environmentId: string;

  /**
   * @generated from field: bool impersonated = 5;
   */
  impersonated: boolean;
};

/**
 * Describes the message chalk.auth.v1.EngineAgent.
 * Use `create(EngineAgentSchema)` to create a new message.
 */
export const EngineAgentSchema: GenMessage<EngineAgent> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_agent, 5);

/**
 * @generated from message chalk.auth.v1.MetadataServiceAgent
 */
export type MetadataServiceAgent = Message<"chalk.auth.v1.MetadataServiceAgent"> & {
};

/**
 * Describes the message chalk.auth.v1.MetadataServiceAgent.
 * Use `create(MetadataServiceAgentSchema)` to create a new message.
 */
export const MetadataServiceAgentSchema: GenMessage<MetadataServiceAgent> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_agent, 6);

/**
 * ExchangeTokenDetails is present on a TenantAgent when it was authenticated
 * via an exchange token. It carries the exchange-specific constraints needed
 * by the GetInternalWorkingToken handler.
 *
 * @generated from message chalk.auth.v1.ExchangeTokenDetails
 */
export type ExchangeTokenDetails = Message<"chalk.auth.v1.ExchangeTokenDetails"> & {
  /**
   * @generated from field: repeated chalk.auth.v1.Permission requestable_permissions = 1;
   */
  requestablePermissions: Permission[];

  /**
   * @generated from field: int32 generation_number = 2;
   */
  generationNumber: number;

  /**
   * @generated from field: string subject = 3;
   */
  subject: string;

  /**
   * @generated from field: string environment_id = 4;
   */
  environmentId: string;

  /**
   * @generated from field: chalk.auth.v1.ExchangeTokenKind kind = 5;
   */
  kind: ExchangeTokenKind;
};

/**
 * Describes the message chalk.auth.v1.ExchangeTokenDetails.
 * Use `create(ExchangeTokenDetailsSchema)` to create a new message.
 */
export const ExchangeTokenDetailsSchema: GenMessage<ExchangeTokenDetails> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_agent, 7);

/**
 * @generated from message chalk.auth.v1.TenantAgent
 */
export type TenantAgent = Message<"chalk.auth.v1.TenantAgent"> & {
  /**
   * Optional team scope.
   *
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * Optional permission list. When non-empty, the token is restricted to only
   * these permissions instead of the default allow-all behaviour.
   *
   * @generated from field: repeated chalk.auth.v1.Permission permissions = 2;
   */
  permissions: Permission[];

  /**
   * Optional environment scope.
   *
   * @generated from field: string environment_id = 3;
   */
  environmentId: string;

  /**
   * Present only when the agent authenticated via an exchange token.
   *
   * @generated from field: optional chalk.auth.v1.ExchangeTokenDetails exchange_token_details = 4;
   */
  exchangeTokenDetails?: ExchangeTokenDetails;

  /**
   * Optional cluster scope. Used to authorize cluster-scoped infrastructure
   * writes (e.g. dataplane-controller container/scaling-group status updates).
   *
   * @generated from field: string cluster_id = 5;
   */
  clusterId: string;
};

/**
 * Describes the message chalk.auth.v1.TenantAgent.
 * Use `create(TenantAgentSchema)` to create a new message.
 */
export const TenantAgentSchema: GenMessage<TenantAgent> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_agent, 8);

/**
 * SelfHostedLicenseAgent is the identity behind a `chlk_sh_` license key: an
 * opaque, revocable bearer token issued to a self-hosted deployment so it can
 * report and read its own usage. The key carries no configurable permissions —
 * the set it may exercise is fixed in code — and the metadata plane accepts it
 * on a narrow allowlist of services rather than the whole API.
 *
 * @generated from message chalk.auth.v1.SelfHostedLicenseAgent
 */
export type SelfHostedLicenseAgent = Message<"chalk.auth.v1.SelfHostedLicenseAgent"> & {
  /**
   * Id of the license key row that authenticated this request.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;

  /**
   * Human-readable label chosen when the key was provisioned.
   *
   * @generated from field: string name = 3;
   */
  name: string;
};

/**
 * Describes the message chalk.auth.v1.SelfHostedLicenseAgent.
 * Use `create(SelfHostedLicenseAgentSchema)` to create a new message.
 */
export const SelfHostedLicenseAgentSchema: GenMessage<SelfHostedLicenseAgent> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_agent, 9);

/**
 * The single notebook a share link grants.
 *
 * @generated from message chalk.auth.v1.NotebookShareScope
 */
export type NotebookShareScope = Message<"chalk.auth.v1.NotebookShareScope"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;
};

/**
 * Describes the message chalk.auth.v1.NotebookShareScope.
 * Use `create(NotebookShareScopeSchema)` to create a new message.
 */
export const NotebookShareScopeSchema: GenMessage<NotebookShareScope> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_agent, 10);

/**
 * What a share link points at. A oneof rather than a (type, id) pair so that
 * each resource kind can carry the identifiers it actually needs, and so adding
 * a kind is a compile error everywhere that must handle it rather than a
 * silently-unhandled string.
 *
 * @generated from message chalk.auth.v1.ResourceShareScope
 */
export type ResourceShareScope = Message<"chalk.auth.v1.ResourceShareScope"> & {
  /**
   * @generated from oneof chalk.auth.v1.ResourceShareScope.scope
   */
  scope: {
    /**
     * @generated from field: chalk.auth.v1.NotebookShareScope notebook = 1;
     */
    value: NotebookShareScope;
    case: "notebook";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.auth.v1.ResourceShareScope.
 * Use `create(ResourceShareScopeSchema)` to create a new message.
 */
export const ResourceShareScopeSchema: GenMessage<ResourceShareScope> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_agent, 11);

/**
 * ResourceShareAgent is the identity behind a share link: an opaque, revocable
 * bearer token granting read-only access to exactly one resource.
 *
 * The token carries no configurable permissions -- the only permission it may
 * exercise is PERMISSION_INTERNAL_RESOURCE_SHARE_VIEW, which no user or service
 * token is ever granted. That permission bounds which endpoints accept the
 * token; it does NOT bound which resource, so every handler reachable with one
 * must additionally check the request against `scope`.
 *
 * @generated from message chalk.auth.v1.ResourceShareAgent
 */
export type ResourceShareAgent = Message<"chalk.auth.v1.ResourceShareAgent"> & {
  /**
   * Id of the share-link row that authenticated this request. The row id is
   * public; the token secret beside it is what authorizes.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;

  /**
   * @generated from field: string environment_id = 3;
   */
  environmentId: string;

  /**
   * The single resource this token may read.
   *
   * @generated from field: chalk.auth.v1.ResourceShareScope scope = 4;
   */
  scope?: ResourceShareScope;

  /**
   * Whether the link's creator additionally required a signed-in team member.
   * Enforced during authentication, before the agent is minted; recorded here
   * for audit and so handlers can surface why a viewer was rejected.
   *
   * @generated from field: bool requires_authentication = 5;
   */
  requiresAuthentication: boolean;
};

/**
 * Describes the message chalk.auth.v1.ResourceShareAgent.
 * Use `create(ResourceShareAgentSchema)` to create a new message.
 */
export const ResourceShareAgentSchema: GenMessage<ResourceShareAgent> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_agent, 12);

/**
 * @generated from message chalk.auth.v1.SandboxPrincipal
 */
export type SandboxPrincipal = Message<"chalk.auth.v1.SandboxPrincipal"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Identifies the sandbox's durable lineage group.
   *
   * @generated from field: string group_id = 2;
   */
  groupId: string;
};

/**
 * Describes the message chalk.auth.v1.SandboxPrincipal.
 * Use `create(SandboxPrincipalSchema)` to create a new message.
 */
export const SandboxPrincipalSchema: GenMessage<SandboxPrincipal> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_agent, 13);

/**
 * WorkloadAgent is an immutable workload principal reconstructed from a signed
 * working token. Ordinary authorization does not load the workload's record.
 *
 * @generated from message chalk.auth.v1.WorkloadAgent
 */
export type WorkloadAgent = Message<"chalk.auth.v1.WorkloadAgent"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;

  /**
   * The complete permission snapshot granted to this workload. Empty grants no
   * permissions.
   *
   * @generated from field: repeated chalk.auth.v1.Permission permissions = 3;
   */
  permissions: Permission[];

  /**
   * @generated from oneof chalk.auth.v1.WorkloadAgent.principal
   */
  principal: {
    /**
     * ScalingGroupPrincipal scaling_group = 5;
     * FunctionPrincipal function = 6;
     *
     * @generated from field: chalk.auth.v1.SandboxPrincipal sandbox = 4;
     */
    value: SandboxPrincipal;
    case: "sandbox";
  } | { case: undefined; value?: undefined };

  /**
   * Immutable environment-scoped data-access policy derived when the workload
   * principal is created.
   *
   * @generated from field: chalk.auth.v1.FeaturePermissions feature_permissions = 7;
   */
  featurePermissions?: FeaturePermissions;

  /**
   * @generated from field: repeated chalk.auth.v1.CustomClaim customer_claims = 8;
   */
  customerClaims: CustomClaim[];

  /**
   * Immutable workload grants, distinct from customer data-access claims.
   *
   * @generated from field: map<string, string> user_provided_claims = 9;
   */
  userProvidedClaims: { [key: string]: string };
};

/**
 * Describes the message chalk.auth.v1.WorkloadAgent.
 * Use `create(WorkloadAgentSchema)` to create a new message.
 */
export const WorkloadAgentSchema: GenMessage<WorkloadAgent> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_agent, 14);

/**
 * @generated from message chalk.auth.v1.Agent
 */
export type Agent = Message<"chalk.auth.v1.Agent"> & {
  /**
   * Sandbox for which the credential was issued. This is signed provenance,
   * independent of the user or service account whose permissions authorize it.
   *
   * @generated from field: string sandbox_id = 8;
   */
  sandboxId: string;

  /**
   * @generated from oneof chalk.auth.v1.Agent.agent
   */
  agent: {
    /**
     * @generated from field: chalk.auth.v1.UserAgent user_agent = 1;
     */
    value: UserAgent;
    case: "userAgent";
  } | {
    /**
     * @generated from field: chalk.auth.v1.ServiceTokenAgent service_token_agent = 2;
     */
    value: ServiceTokenAgent;
    case: "serviceTokenAgent";
  } | {
    /**
     * @generated from field: chalk.auth.v1.EngineAgent engine_agent = 3;
     */
    value: EngineAgent;
    case: "engineAgent";
  } | {
    /**
     * @generated from field: chalk.auth.v1.TenantAgent tenant_agent = 4;
     */
    value: TenantAgent;
    case: "tenantAgent";
  } | {
    /**
     * @generated from field: chalk.auth.v1.MetadataServiceAgent metadata_service_agent = 5;
     */
    value: MetadataServiceAgent;
    case: "metadataServiceAgent";
  } | {
    /**
     * @generated from field: chalk.auth.v1.SelfHostedLicenseAgent self_hosted_license_agent = 6;
     */
    value: SelfHostedLicenseAgent;
    case: "selfHostedLicenseAgent";
  } | {
    /**
     * @generated from field: chalk.auth.v1.ResourceShareAgent resource_share_agent = 7;
     */
    value: ResourceShareAgent;
    case: "resourceShareAgent";
  } | {
    /**
     * @generated from field: chalk.auth.v1.WorkloadAgent workload_agent = 9;
     */
    value: WorkloadAgent;
    case: "workloadAgent";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.auth.v1.Agent.
 * Use `create(AgentSchema)` to create a new message.
 */
export const AgentSchema: GenMessage<Agent> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_agent, 15);

/**
 * @generated from enum chalk.auth.v1.ExchangeTokenKind
 */
export enum ExchangeTokenKind {
  /**
   * @generated from enum value: EXCHANGE_TOKEN_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EXCHANGE_TOKEN_KIND_INTERNAL_SERVICE = 1;
   */
  INTERNAL_SERVICE = 1,

  /**
   * @generated from enum value: EXCHANGE_TOKEN_KIND_USER = 2;
   */
  USER = 2,

  /**
   * @generated from enum value: EXCHANGE_TOKEN_KIND_SERVICE_TOKEN = 3;
   */
  SERVICE_TOKEN = 3,

  /**
   * @generated from enum value: EXCHANGE_TOKEN_KIND_SANDBOX = 4;
   */
  SANDBOX = 4,
}

/**
 * Describes the enum chalk.auth.v1.ExchangeTokenKind.
 */
export const ExchangeTokenKindSchema: GenEnum<ExchangeTokenKind> = /*@__PURE__*/
  enumDesc(file_chalk_auth_v1_agent, 0);

/**
 * @generated from enum chalk.auth.v1.AgentKind
 */
export enum AgentKind {
  /**
   * @generated from enum value: AGENT_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_KIND_USER = 1;
   */
  USER = 1,

  /**
   * @generated from enum value: AGENT_KIND_SERVICE_TOKEN = 2;
   */
  SERVICE_TOKEN = 2,

  /**
   * @generated from enum value: AGENT_KIND_ENGINE = 3;
   */
  ENGINE = 3,

  /**
   * @generated from enum value: AGENT_KIND_TENANT = 4;
   */
  TENANT = 4,

  /**
   * @generated from enum value: AGENT_KIND_METADATA_SERVICE = 5;
   */
  METADATA_SERVICE = 5,

  /**
   * @generated from enum value: AGENT_KIND_SELF_HOSTED_LICENSE = 6;
   */
  SELF_HOSTED_LICENSE = 6,

  /**
   * @generated from enum value: AGENT_KIND_RESOURCE_SHARE = 7;
   */
  RESOURCE_SHARE = 7,

  /**
   * @generated from enum value: AGENT_KIND_SANDBOX = 8;
   */
  SANDBOX = 8,
}

/**
 * Describes the enum chalk.auth.v1.AgentKind.
 */
export const AgentKindSchema: GenEnum<AgentKind> = /*@__PURE__*/
  enumDesc(file_chalk_auth_v1_agent, 1);

